import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';

import { cx } from '@emotion/css';

const areasColumn1 = [
  'Queensbury NW9',
  'Beckenham SE20',
  'Arkley NW7',
  'Bexleyheath SE2',
  'Woodford E18',
  'Mile End E1',
  'Ratcliff E1',
  'Shadwell E1',
  'Spitalfields E1',
  'Stepney E1',
  'Wapping E1',
  'Whitechapel E1',
  'Lea Bridge E10',
  'Leyton E10, E15',
  'Cann Hall E11',
  'Leytonstone E11',
  'Snaresbrook E11',
  'Wanstead E11',
  'Little Ilford E12',
  'Manor Park E12',
  'Plaistow E13',
  'West Ham E13, E15',
  'Blackwall E14',
  'Canary Wharf E14',
  'Cubitt Town E14',
  'Isle of Dogs E14',
  'Leamouth E14',
  'Limehouse E14',
  'Millwall E14',
  'Poplar E14',
  'Maryland E15',
  'Stratford E15',
  'Stratford City E15, E20',
  'Canning Town E16',
  'Custom House E16',
  'North Woolwich E16',
  'Silvertown E16',
  'Upper Walthamstow E17',
  'Walthamstow E17',
  'Walthamstow Village E17',
  'South Woodford E18',
  'Bethnal Green E2',
  'Cambridge Heath E2',
  'Haggerston E2',
  'Bow E3',
  'Bromley (also Bromley-by-Bow) E3',
  'Old Ford E3',
  'Chingford E4',
  'Highams Park E4',
  'Lower Clapton E5',
  'Upper Clapton E5',
  'Hackney E5, E8, E9, N1, N16',
  'East Ham E6',
  'Upton Park E6, E13',
  'Beckton E6, E16',
  'Forest Gate E7',
  'Dalston E8',
  'Hackney Central E8',
  'Shacklewell E8, N16',
  'Hackney Marshes E9',
  'Hackney Wick E9',
  'Homerton E9',
  'South Hackney E9',
  'Clerkenwell EC1',
  'Farringdon EC1',
  'Finsbury EC1',
  "St Luke's EC1",
  'Barbican EC1, EC2',
  'Angel EC1, N1',
  'Aldgate EC3',
  'Tower Hill EC3',
  'Blackfriars EC4',
  'Temple EC4, WC2',
  'Barnsbury N1',
  'Canonbury N1',
  'De Beauvoir Town N1',
  'Hoxton N1',
  'Islington N1',
  'Pentonville N1',
  'Shoreditch N1',
  "King's Cross N1, N1C, NW1, WC1",
  'Fortis Green N10',
  'Muswell Hill N10',
  'Brunswick Park N11',
  'Friern Barnet N11',
  'New Southgate N11',
  'Colney Hatch N11, N10',
  'Arnos Grove N11, N14',
  'Bounds Green N11, N22',
  'North Finchley N12',
  'Woodside Park N12',
  'Palmers Green N13',
  'Osidge N14',
  'Southgate N14',
  'Seven Sisters N15',
  'Tottenham Green N15',
  'West Green N15',
  'Stamford Hill N15, N16',
  'South Tottenham N15, N17',
  'Tottenham N15, N17',
  'Tottenham Hale N15, N17',
  'Stoke Newington N16',
  'West Hackney N16',
  'Northumberland Park N17',
  'Archway N19',
  'Upper Holloway N19',
  "King's Cross Central N1C",
  'East Finchley N2',
  'Hampstead Garden Suburb N2',
  'Finchley N2, N3, N12',
  'Oakleigh Park N20',
  'Totteridge N20',
  'Whetstone N20',
  'Grange Park N21',
  'Winchmore Hill N21',
  'Bowes Park N22',
  'Wood Green N22',
  'Church End N3',
  'Finsbury Park N4',
  'Manor House N4',
  'Stroud Green N4',
  'Harringay N4, N8, N15',
  'Highbury N5',
  'Highgate N6',
  'Holloway N7',
];

const areasColumn2 = [
  'Tufnell Park N7, N19',
  'Crouch End N8',
  'Hornsey N8',
  'Turnpike Lane N8',
  'Edmonton N9, N18',
  'Camden Town NW1',
  'Chalk Farm NW1',
  'Somerstown NW1',
  'Primrose Hill NW1, NW3, NW8',
  'Brent Park NW10',
  'Church End NW10',
  'Harlesden NW10',
  'Old Oak Common NW10',
  'Park Royal NW10',
  'Stonebridge NW10',
  'Willesden NW10',
  'Kensal Green NW10, NW6',
  'Golders Green NW11',
  'Temple Fortune NW11',
  'Childs Hill NW2',
  'Cricklewood NW2',
  'Dollis Hill NW2',
  'Neasden NW2, NW10',
  'Brent Cross NW2, NW4',
  'Belsize Park NW3',
  'Frognal NW3',
  'Hampstead NW3',
  'North End NW3',
  'Swiss Cottage NW3',
  'Burroughs, The NW4',
  'Hendon NW4',
  'Kentish Town NW5',
  'Gospel Oak NW5, NW3',
  'Brondesbury NW6',
  'Kilburn NW6',
  "Queen's Park NW6",
  'West Hampstead NW6',
  'Hale, The NW7',
  'Mill Hill NW7',
  'Barnet Gate NW7',
  'Lisson Grove NW8',
  "St John's Wood NW8",
  'Colindale NW9',
  'Grahame Park NW9',
  'Hyde, The NW9',
  'Kingsbury NW9',
  'West Hendon NW9',
  'Bankside SE1',
  'Bermondsey SE1',
  'Lambeth SE1',
  'Southwark SE1',
  'Elephant and Castle SE1, SE11, SE17',
  'Newington SE1, SE17',
  'Greenwich SE10',
  'Maze Hill SE10',
  'Kennington SE11',
  'Chinbrook SE12',
  'Grove Park SE12',
  'Horn Park SE12',
  'Lee SE12',
  'Hither Green SE13',
  'Lewisham SE13',
  'New Cross SE14',
  'Nunhead SE15',
  'Peckham SE15',
  'Rotherhithe SE16',
  'Surrey Quays SE16',
  'Walworth SE17',
  'Plumstead SE18',
  "Shooter's Hill SE18",
  'Woolwich SE18',
  'Upper Norwood SE19',
  'Crystal Palace SE19, SE20, SE26',
  'Gipsy Hill SE19, SE27',
  'Abbey Wood SE2',
  'Crossness SE2',
  'West Heath SE2',
  'Anerley SE20',
  'Penge SE20',
  'Dulwich SE21',
  'West Dulwich SE21',
  'Dulwich Village SE21, SE22',
  'Sydenham Hill SE21, SE26',
  'East Dulwich SE22',
  'Forest Hill SE23',
  'Honor Oak SE23',
  'Herne Hill SE24',
  'Selhurst SE25',
  'South Norwood SE25',
  'Sydenham SE26',
  'West Norwood SE27',
  'Thamesmead SE28, SE2',
  'Blackheath SE3',
  'Kidbrooke SE3',
  'Westcombe Park SE3',
  'Blackheath Royal Standard SE3, SE12',
  'Brockley SE4',
  'Crofton Park SE4',
  'St Johns SE4',
  'Ladywell SE4, SE13',
  'Camberwell SE5',
  'Denmark Hill SE5',
  'Bellingham SE6',
  'Catford SE6',
  'Southend SE6',
  'Bell Green SE6, SE26',
  'Charlton SE7',
  'Deptford SE8',
  'Eltham SE9',
  'Middle Park SE9',
  'Mottingham SE9',
  'New Eltham SE9',
  'Well Hall SE9',
  'Longlands SE9',
  'Falconwood SE9',
  'Belgravia SW1',
  'Knightsbridge SW1',
  'Millbank SW1',
  'Pimlico SW1',
  "St James's SW1",
  'Westminster SW1',
  'West Brompton SW10',
  'Battersea SW11',
  'Clapham Junction SW11',
  'Balham SW12',
];

const areasColumn3 = [
  'Barnes SW13',
  'Castelnau SW13',
  'East Sheen SW14',
  'Mortlake SW14',
  'Kingston Vale SW15',
  'Putney SW15',
  'Roehampton SW15',
  'Norbury SW16',
  'Streatham SW16',
  'Tooting SW17',
  'Tooting Bec SW17',
  'Earlsfield SW18',
  'Wandsworth SW18',
  'Southfields SW18, SW19',
  'Colliers Wood SW19',
  'Merton Park SW19',
  'South Wimbledon SW19',
  'Wimbledon SW19, SW20',
  'Tulse Hill SW2, SE27',
  'Brixton SW2, SW9, SE5',
  'Raynes Park SW20',
  'Brompton SW3',
  'Chelsea SW3',
  'Clapham SW4',
  'Earls Court SW5, SW10',
  'Fulham SW6',
  'Parsons Green SW6',
  'Sands End SW6',
  'Kensington SW7',
  'South Kensington SW7, SW3, SW5',
  'Nine Elms SW8',
  'Vauxhall SW8',
  'Stockwell SW8, SW9',
  'Oval SW8, SW9, SE11',
  'Hounslow TW3',
  'Brentford TW8',
  'Kew TW9',
  'North Sheen TW9',
  'Richmond TW9',
  'Chinatown W1',
  'Fitzrovia W1',
  'Marylebone (also St Marylebone) W1',
  'Mayfair W1',
  'Soho W1',
  'North Kensington W10, W11',
  'Notting Hill W11',
  "Shepherd's Bush W12",
  'White City W12',
  'Wormwood Scrubs W12',
  'West Ealing W13',
  'West Kensington W14',
  'Bayswater W2',
  'Paddington W2',
  'Acton W3, W4',
  'Acton Green W4',
  'Bedford Park W4',
  'Chiswick W4',
  'Grove Park W4',
  'Gunnersbury W4',
  'Old Chiswick W4',
  'Ealing W5, W13',
  'Hammersmith W6',
  'Hanwell W7',
  'Holland Park W8, W11, W14',
  'Maida Vale W9',
  'Little Venice W9, W2',
  'Bloomsbury WC1',
  'St Pancras WC1',
  'Holborn WC1, WC2',
  'Aldwych WC2',
  'Charing Cross WC2',
  'Covent Garden WC2',
  'St Giles WC2',
];

// Export all areas for sitemap generation
export const getAllAreas = () => {
  return [...areasColumn1, ...areasColumn2, ...areasColumn3];
};

export const PostCodes = ({ styles, mainPageUrl }: any) => {
  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

  const formatAreaUrl = (text: string) => {
    return mainPageUrl + '/' + text.replace(/,/g, '').replace(/\s+/g, '-');
  };

  return (
    <section className={styles.offeringwide}>
      <div className={styles.container}>
        <div className={cx(styles.inner_section, styles.root)}>
          <h3 className={cx(styles.site_title, styles.h3)}>
            Offering a wide range of top-notch services tailored to your needs
          </h3>
          <div className={styles.areas_cover}>
            <button className={styles.view_more_btn} onClick={toggleClass}>
              View areas we cover{' '}
              <Image
                src="/images/services/heat-and-gas/btn-arrow.svg"
                alt="more button icon"
                height={10}
                width={17}
                className={
                  isActive
                    ? cx(
                        styles.view_more_btn_img,
                        styles.view_more_btn_img_active,
                      )
                    : styles.view_more_btn_img
                }
              />
            </button>
          </div>
        </div>
        <div
          className={
            isActive
              ? cx(styles.areas_lising, styles.areas_lising_show)
              : styles.areas_lising
          }>
          <div className={styles.areas_lising_inner}>
            <div className={styles.areas_lising_wrap}>
              <ul className={styles.alw_ul}>
                {areasColumn1.map((area, index) => (
                  <li key={index} className={styles.alw_li}>
                    <Link href={formatAreaUrl(area)}>{area}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.areas_lising_wrap}>
              <ul className={styles.alw_ul}>
                {areasColumn2.map((area, index) => (
                  <li key={index} className={styles.alw_li}>
                    <Link href={formatAreaUrl(area)}>{area}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.areas_lising_wrap}>
              <ul className={styles.alw_ul}>
                {areasColumn3.map((area, index) => (
                  <li key={index} className={styles.alw_li}>
                    <Link href={formatAreaUrl(area)}>{area}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
